;"use strict";

!(function (){

    /*********     START ANIMATION ON LOAD WINDOW             ********/
    function animateBlock(elem, animate_class, delay){
        setTimeout(function (){
            elem.addClass(animate_class);
        }, delay);
    }

    animateBlock($(".billy_banner__bg"), "slided o1",200);
    animateBlock($(".slider1_wrap img.slider1_img"),"slided o1", 1000);
    animateBlock($(".slider1_wrap"),"slided o1", 1500);
    animateBlock($(".slider1_inner"),"slided o1", 2000);
    animateBlock($(".slider2"), "slided o1",2300);
    animateBlock($(".slider3"), "slided o1",2600);
    animateBlock($(".slider4"), "slided o1",2900);



    $(window).on("resize", function (){
        setTimeout(function (){
            $('.slider1, .slider2, .slider3, .slider4').trigger('destroy.owl.carousel');
        }, 200);
        setTimeout(function (){
            $('.slider1, .slider2, .slider3, .slider4').owlCarousel({
                loop: true,
                margin: 0,
                nav: false,
                items: 1,
                dots: false,
                autoplay: false,
                smartSpeed: 750,
                autoplayTimeout: 3000,
                mouseDrag: false,
                touchDrag: false
            });
        }, 400);
    });

    /*setTimeout(function (){
        $(".slider1").slick({
            infinite: true,
            dots: false,
            speed: 500,
            fade: true,
            arrows: false,
            cssEase: 'linear',
            autoplay: false,
            autoplaySpeed: 1500,
        });
    }, 0);
    setTimeout(function (){
        $(".slider2").slick({
            adaptiveHeight: false,
            infinite: true,
            dots: false,
            arrows: false,
            speed: 500,
            cssEase: 'linear',
            autoplay: false,
            autoplaySpeed: 2500,
        });
    }, 1000);
    setTimeout(function (){
        $(".slider3").slick({
            infinite: true,
            dots: false,
            speed: 500,
            arrows: false,
            cssEase: 'linear',
            autoplay: false,
            autoplaySpeed: 1800,
        });
    }, 1500);
    setTimeout(function (){
        $(".slider4").slick({
            infinite: true,
            dots: false,
            speed: 500,
            arrows: false,
            cssEase: 'linear',
            autoplay: false,
            autoplaySpeed: 1200,
        });
    }, 2000);*/

    /*********     END ANIMATION ON LOAD WINDOW               ********/





    setTimeout(function() {

        $(".slider1").owlCarousel({
            loop: true,
            margin: 0,
            nav: false,
            items: 1,
            dots: false,
            autoplay: false,
            smartSpeed: 750,
            autoplayTimeout: 3000,
            mouseDrag: false,
            touchDrag: false
        });
        $(".slider2").owlCarousel({
            loop: true,
            margin: 0,
            nav: false,
            items: 1,
            dots: false,
            autoplay: false,
            smartSpeed: 750,
            autoplayTimeout: 3000,
            mouseDrag: false,
            touchDrag: false
        });
        $(".slider3").owlCarousel({
            loop: true,
            margin: 0,
            nav: false,
            items: 1,
            dots: false,
            autoplay: false,
            smartSpeed: 750,
            autoplayTimeout: 3000,
            mouseDrag: false,
            touchDrag: false
        });
        $(".slider4").owlCarousel({
            loop: true,
            margin: 0,
            nav: false,
            items: 1,
            dots: false,
            autoplay: false,
            smartSpeed: 750,
            autoplayTimeout: 3000,
            mouseDrag: false,
            touchDrag: false
        });

        $(".billy_banner__list .list_steps div[data-index]").each(function (i, elem){
            $(elem).on("click", function (e){
                clearInterval(myInterval);
                $(".billy_banner__list .list_steps").removeClass("go");
                counter = null;

                console.log("STOP");

                $("[data-steps]").attr("data-steps", " ");
                $("[data-steps]").attr("data-steps", i);

                $(".billy_banner__list .list_steps div[data-index]").removeClass("active");
                $(this).addClass("active");

                //$('.slider1').slick('slickGoTo', i);
                $('.slider1').trigger('to.owl.carousel', i)
                $('.slider2').trigger('to.owl.carousel', i)
                $('.slider3').trigger('to.owl.carousel', i)
                $('.slider4').trigger('to.owl.carousel', i)
            });
        });


        $(".billy_banner__list .list_steps").addClass("go");
        var counter = 0;
        var myInterval = setInterval(function () {
            ++counter;
            //console.log(counter);
            if(counter == 1) {
                $(".item[data-index]").removeClass("active");
                $(".item[data-index=1]").addClass("active");
            }else if(counter == 9){
                $(".item[data-index]").removeClass("active");
                $(".item[data-index=2]").addClass("active");
            }else if(counter == 18){
                $(".item[data-index]").removeClass("active");
                $(".item[data-index=3]").addClass("active");
            }


            if(counter == 9 || counter == 18 || counter == 27){
                //console.log(counter);
                $(".slider1").trigger('next.owl.carousel');
                $(".slider2").trigger('next.owl.carousel');
                $(".slider3").trigger('next.owl.carousel');
                $(".slider4").trigger('next.owl.carousel');
            }
            if(counter >= 27){
                counter = 0;
                $(".list_steps").removeClass("go");
                $(".item[data-index]").removeClass("active");
            }else{
                $(".billy_banner__list .list_steps").addClass("go");
            }
        }, 1000);
    }, 700);



})(jQuery);